module.exports = __webpack_public_path__ + "media/npc_dota_hero_kunkka.010e762e.webm";